import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
import BillingReport from '../../components/Billing/Reports/BillingReport';

const GuestInvoicesReportPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');

    return (
        <Box sx={{ Top: isMobile ? '30px' : '0px' }}>
            <BillingReport />
        </Box>
    );
};

export default GuestInvoicesReportPage;
